<div class="main-div">
    <div class="row ms-0 me-0" id="aviation-logistics">
        <div class="col-xl-6 ps-0 pe-0 arrow-overlap-img">
            <img src="../assets/images/our-services/verticals/aviation-logistics.jpg" alt="Aviation Logistics" class="img-fluid w-100">
        </div>
        <div class="col-xl-6 bg-img-top">
            <div class="ps-50 pe-50 pt-50 res-ps-15 res-pe-15">
                <h2 class="mb-3"><span class="number">01.</span> Aviation Logistics</h2>
                <p class="font-16">We provide AOG / airside services at all airports globally​ with control towers in Singapore, Copenhagen and New York for 24/7/365 service in all time zones​.
                    <br><br> Our global network allows us to meet your requirements and offer customs clearing services at all destinations. Our shipments are monitored from departure to arrival with alerts en route and notification of delivery or delay,
                    whatever the reason, to provide our customers with total visibility.
                    <!-- <br><br> For more information or 24-hour service, contact your <a href="javascript:void(0);" routerLink="/contact" class="more-link">local office</a> -->
                </p>
            </div>
        </div>
    </div>

    <div class="row ms-0 me-0" id="marine-logistics">
        <div class="col-xl-6 ps-0 pe-0 order-2 res-order-1 arrow-overlap-img-top">
            <img src="../assets/images/our-services/verticals/marine-logistics.jpg" alt="Marine Logistics" class="img-fluid w-100">
        </div>
        <div class="col-xl-6 order-1 bg-img-bottom">
            <div class="ps-50 pe-50 pt-50 res-ps-15 res-pe-15">
                <h2 class="mb-3"><span class="number">02.</span> Marine Logistics</h2>
                <p class="font-16">With a global network of dedicated Marine Logistics experts in key locations, we have vast experience in handling highly specialized solutions within the industry​. We provide global delivery of ship spares and marine parts door-to-deck,
                    door-to-port and door-to-airport.
                    <br><br> Take advantage of our consultancy services to ensure exemption of duties and taxes, whenever possible​, and to expedite customs clearance.
                    <br><br> Contact your <a href="javascript:void(0);" routerLink="/contact" class="more-link">local office</a> for service 24/7/365.
                </p>
            </div>
        </div>
    </div>

    <div class="row ms-0 me-0" id="fasion-logistics">
        <div class="col-xl-6 ps-0 pe-0 arrow-overlap-img-top">
            <img src="../assets/images/our-services/verticals/fasion-logistics.jpg" alt="Fashion Logistics" class="img-fluid w-100">
        </div>
        <div class="col-xl-6 bg-img-top">
            <div class="ps-50 pe-50 pt-50 res-ps-15 res-pe-15">
                <h2 class="mb-3"><span class="number">03.</span> Fashion Logistics</h2>
                <p class="font-16"> From factory to retail floor, we can provide custom transportation and distribution solutions for your latest collection to include quality control, inspection and tracking.</p>
                <p class="font-16"> With our state-of-the-art warehousing facilities, we can additionally provide short- or long-term storage, pick & pack, order management and more.</p>
                <p class="font-16"> Contact your <a href="javascript:void(0);" routerLink="/contact" class="more-link">local office</a> to explore your options.</p>
            </div>
        </div>
    </div>
</div>